export {default as UserModel} from './User/model'
export {default as UserSelector} from './User/selector'



// WEBPACK FOOTER //
// src/model/index.js